import { Outlet } from "react-router-dom";

function PageContent() {
  return (
    <div className="pageContent">
      <Outlet />
    </div>
  );
}
export default PageContent;
